export default __webpack_public_path__ + "static/clientScrollGreenBg-05da14a0840c5bd47269be4354d28e2c.png";